export default import.meta.ROLLDOWN_FILE_URL_Vn0x6hYnhSZIl_YmIM6XzA